import React from 'react';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmNewChatModal: React.FC<IProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div className={style.confirmNewChatModal}>
      <ModalHeader onClose={onCancel} />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>{t('Start a New Chat')}</div>
        <div className={style.modalBodyConfirmText}>
          {t('Are you sure you want to start a new chat?')}
          <br />
          {t('This will permanently clear the current conversation.')}
          <br />
          {t('Please copy any important information before starting a new chat.')}
          <br />
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="secondary" variant="small" text={t('Cancel')} onClick={onCancel} />
        <Button type="primary" variant="small" text={t('Start new chat')} onClick={onConfirm} />
      </div>
    </div>
  );
};

export default ConfirmNewChatModal;
